
import CheckpointMasterNotFoundSvgComponent from '../../assets/svg-components/not-found/checkpoint-master';
import './index.scss';

export default function VCMasterNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/checkpoint-master.svg"
            className="not-found-image img-fluid not-found-image-checkpoint-master"
          /> */}
          <div className='not-found-image  not-found-image-checkpoint-master'>
            <CheckpointMasterNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">Your organisation currently has no location mapped. Please get in touch with the Lexcare administrator to have location mapped.</p>
        </div>
      </div>
    </>
  );
}
